import { isOneOfTags } from 'anodum';
import {
  BLOCK_ELEMENTS,
  BREAK_TAG,
  DEFAULT_BLOCK_TAG,
  LIST_ELEMENTS,
  LIST_ITEM,
} from '../constants/editable-elements';
import textFormatting from '../../text-formatting';

const handleEmptyContentEditableSelection = (liveContentEditable, pasteElement) => {
  const selection = textFormatting.accessors.getAdvancedSelection();
  const { ownerDocument: liveDocument } = liveContentEditable;
  const relatedBlockElement = pasteElement.querySelector([...BLOCK_ELEMENTS, ...LIST_ELEMENTS]);
  const relatedTag = relatedBlockElement ? relatedBlockElement.tagName : DEFAULT_BLOCK_TAG;
  const newElement = liveDocument.createElement(relatedTag);

  const breakNode = liveDocument.createElement(BREAK_TAG);
  let elementToAppend = breakNode;
  if (relatedBlockElement && isOneOfTags(relatedBlockElement, LIST_ELEMENTS)) {
    elementToAppend = liveDocument.createElement(LIST_ITEM);
    const clonedListItemNode = relatedBlockElement
      .querySelector(LIST_ITEM)
      .firstElementChild.cloneNode();
    clonedListItemNode.innerHTML = '';
    clonedListItemNode.appendChild(breakNode);
    elementToAppend.appendChild(clonedListItemNode);
  }
  newElement.appendChild(elementToAppend);
  // eslint-disable-next-line no-param-reassign
  liveContentEditable.innerHTML = '';
  liveContentEditable.appendChild(newElement);
  const breakNodeParent = breakNode.parentNode;
  selection.nativeSelection.setBaseAndExtent(breakNodeParent, 0, breakNodeParent, 0);
  selection.refresh();
};

export default handleEmptyContentEditableSelection;
